import { createContext } from 'react';
import type { FarmState } from './FarmProvider';

const FarmContext = createContext({} as FarmState);

export default FarmContext;
